/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1CourseregistrationDocumentStatusMutationRequest,
  PostApiV1CourseregistrationDocumentStatusMutationResponse,
  PostApiV1CourseregistrationDocumentStatus400,
  PostApiV1CourseregistrationDocumentStatus401,
  PostApiV1CourseregistrationDocumentStatus500,
} from "../../types/courseRegistrationDocumentController/PostApiV1CourseregistrationDocumentStatus.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1CourseregistrationDocumentStatus } from "../../clients/courseRegistrationDocumentController/postApiV1CourseregistrationDocumentStatus.ts";

export const postApiV1CourseregistrationDocumentStatusMutationKey = () =>
  [{ url: "/api/v1/courseregistration/document/status" }] as const;

export type PostApiV1CourseregistrationDocumentStatusMutationKey = ReturnType<
  typeof postApiV1CourseregistrationDocumentStatusMutationKey
>;

export function postApiV1CourseregistrationDocumentStatusMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1CourseregistrationDocumentStatusMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1CourseregistrationDocumentStatusMutationKey();
  return mutationOptions<
    PostApiV1CourseregistrationDocumentStatusMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationDocumentStatus400
      | PostApiV1CourseregistrationDocumentStatus401
      | PostApiV1CourseregistrationDocumentStatus500
    >,
    { data?: PostApiV1CourseregistrationDocumentStatusMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1CourseregistrationDocumentStatus(data, config);
    },
  });
}

/**
 * @description Altera o status de um documento de matrícula para aprovado, aprovado provisório, pendente ou rejeitado, com opção de incluir motivo de rejeição. Retorna o novo status geral da documentação do curso e informações sobre status. **(Requer Authorization para autenticação)**
 * @summary Altera o status de um documento de matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/document/status}
 */
export function usePostApiV1CourseregistrationDocumentStatus<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1CourseregistrationDocumentStatusMutationResponse,
      ResponseErrorConfig<
        | PostApiV1CourseregistrationDocumentStatus400
        | PostApiV1CourseregistrationDocumentStatus401
        | PostApiV1CourseregistrationDocumentStatus500
      >,
      { data?: PostApiV1CourseregistrationDocumentStatusMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1CourseregistrationDocumentStatusMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1CourseregistrationDocumentStatusMutationKey();

  const baseOptions = postApiV1CourseregistrationDocumentStatusMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1CourseregistrationDocumentStatusMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationDocumentStatus400
      | PostApiV1CourseregistrationDocumentStatus401
      | PostApiV1CourseregistrationDocumentStatus500
    >,
    { data?: PostApiV1CourseregistrationDocumentStatusMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1CourseregistrationDocumentStatusMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationDocumentStatus400
      | PostApiV1CourseregistrationDocumentStatus401
      | PostApiV1CourseregistrationDocumentStatus500
    >,
    { data?: PostApiV1CourseregistrationDocumentStatusMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1CourseregistrationDocumentStatusMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationDocumentStatus400
      | PostApiV1CourseregistrationDocumentStatus401
      | PostApiV1CourseregistrationDocumentStatus500
    >,
    { data?: PostApiV1CourseregistrationDocumentStatusMutationRequest },
    TContext
  >;
}
